import React, { useState } from 'react';
import axios from 'axios';

const TaxReport = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    const generateReport = async () => {
        if (!startDate || !endDate) {
            alert('Please select both start and end dates');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get('/api/reports/tax-classes', {
                params: { startDate, endDate }
            });

            setReportData(response.data);
        } catch (error) {
            console.error('Error fetching report:', error);
            alert('Error generating report');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-header bg-light">
                    <h5 className="mb-0">Tax Class Report</h5>
                </div>
                <div className="card-body">
                    {/* Date Selection */}
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <label className="form-label">Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">End Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4 d-flex align-items-end">
                            <button 
                                className="btn btn-primary"
                                onClick={generateReport}
                                disabled={loading}
                            >
                                {loading ? 'Generating...' : 'Generate Report'}
                            </button>
                        </div>
                    </div>

                    {reportData && (
                        <>
                            {/* Main Tax Class Table */}
                            <h6 className="mb-3">Tax Class Breakdown</h6>
                            <div className="table-responsive mb-4">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Tax Class</th>
                                            <th>Tax Status</th>
                                            <th className="text-end">Cases</th>
                                            <th className="text-end">Gallons</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Under 14% */}
                                        <tr>
                                            <td rowSpan="2">Under 14%</td>
                                            <td>TAX PAID</td>
                                            <td className="text-end">{reportData.under14.paid.cases}</td>
                                            <td className="text-end">{reportData.under14.paid.gallons.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>IN BOND</td>
                                            <td className="text-end">{reportData.under14.bond.cases}</td>
                                            <td className="text-end">{reportData.under14.bond.gallons.toFixed(2)}</td>
                                        </tr>

                                        {/* 14-16% */}
                                        <tr>
                                            <td rowSpan="2">14-16%</td>
                                            <td>TAX PAID</td>
                                            <td className="text-end">{reportData.between14and16.paid.cases}</td>
                                            <td className="text-end">{reportData.between14and16.paid.gallons.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>IN BOND</td>
                                            <td className="text-end">{reportData.between14and16.bond.cases}</td>
                                            <td className="text-end">{reportData.between14and16.bond.gallons.toFixed(2)}</td>
                                        </tr>

                                        {/* Over 16% */}
                                        <tr>
                                            <td rowSpan="2">Over 16%</td>
                                            <td>TAX PAID</td>
                                            <td className="text-end">{reportData.over16.paid.cases}</td>
                                            <td className="text-end">{reportData.over16.paid.gallons.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>IN BOND</td>
                                            <td className="text-end">{reportData.over16.bond.cases}</td>
                                            <td className="text-end">{reportData.over16.bond.gallons.toFixed(2)}</td>
                                        </tr>

                                        {/* Totals */}
                                        <tr className="table-secondary fw-bold">
                                            <td colSpan="2">Total</td>
                                            <td className="text-end">
                                                {reportData.totals.cases}
                                            </td>
                                            <td className="text-end">
                                                {reportData.totals.gallons.toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Adjustment Type Breakdown */}
                            <h6 className="mb-3">Adjustment Type Breakdown</h6>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Adjustment Type</th>
                                            <th className="text-end">Cases</th>
                                            <th className="text-end">Gallons</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Bill of Lading</td>
                                            <td className="text-end">{reportData.byType.BOL.cases}</td>
                                            <td className="text-end">{reportData.byType.BOL.gallons.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Manual Adjustments</td>
                                            <td className="text-end">{reportData.byType.MANUAL.cases}</td>
                                            <td className="text-end">{reportData.byType.MANUAL.gallons.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Initial Inventory</td>
                                            <td className="text-end">{reportData.byType.INITIAL.cases}</td>
                                            <td className="text-end">{reportData.byType.INITIAL.gallons.toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TaxReport;
